import React from "react";

const TooltipPrimary = (props) => {
  const { children, text, align, className, onClick, style } = props;
  return (
    <div className={`tooltip-primary ${align} ${className}`} style={style} onClick={onClick}>
      {children}
      {text && (
        <div className="tooltip hd-mb">
          <p>{text}</p>
        </div>
      )}
    </div>
  );
};

export default TooltipPrimary;
